<template>
  <!-- front -->
  <v-container class="text-center" :class="view">

    <!-- do not make fixed, button is not centered -->
    <v-btn class="mx-2 my-3" fab depressed color="pTeal" to="/createapost">
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <Textpost v-for="social in socials" :key="social.id" class="feed-post">
      <template slot="post-avatar" ><v-img :src="user(social.authorId).profilePic"></v-img></template>
      <template slot="username">{{user(social.authorId).username}}</template>
      <template slot="post-title">{{ social.title }}</template>
      <template slot="post-body">{{ social.text }}</template>
      <template slot="time">{{ social.date | date }}</template>

      <v-img contain v-if="social.imageUrl"
        max-height="500px"
        :src="social.imageUrl !== '' ? social.imageUrl : false"
        slot="post-img"></v-img>

      <template slot="button"><v-btn @click="likeThisPost(social)" contain>
          <v-icon v-if="likedPosts(social.id)" class="mr-1" color="pink">mdi-heart</v-icon>
          <v-icon v-else class="mr-1" >mdi-heart</v-icon>
        <span class="subheading mr-2">{{social.likes}}</span>
        </v-btn></template>
        <template slot="button" ><v-btn contain :to="'/feed/' + social.id">
          <v-icon class="mr-1">list</v-icon>
        </v-btn></template>
    </Textpost>


    <div class="d-flex justify-end">
      <v-btn fab elevation="1" @click="$vuetify.goTo(0, 500)">
        <v-icon>mdi-chevron-up</v-icon>
      </v-btn>
    </div>
  </v-container>


</template>

<script>

import Textpost from '@/components/Frontend/TextPost.vue'

  export default {
    data: () => ({
      view: 'lg',
    }),
    computed: {
      socials() {
        return this.$store.state.fetchFeed
      }
    },
    components: {
      Textpost,
    },
    methods: {
      user(social) {
        return this.$store.state.allUsers[social]
      },
      likedPosts(social){
        return this.$store.state.postInteraction[social]
      },
      likeThisPost(social) {
        if(!this.$store.state.postInteraction[social.id]){
          this.$store.getters.fetchFeed(social.id).likes= this.$store.getters.fetchFeed(social.id).likes + 1
        }
        else {
          this.$store.getters.fetchFeed(social.id).likes= this.$store.getters.fetchFeed(social.id).likes === 1  ? 0 : this.$store.getters.fetchFeed(social.id).likes - 1
        }

        this.$store.dispatch('firebaseAddLikedPost', {
          id: social.id,
          likes: social.likes,
          liked: this.$store.state.postInteraction[social.id] !== true ? true : false,
          public: social.public,
          authorId: social.authorId
        })
     //   this.$store.dispatch('fetchFeed')
      //   this.$store.dispatch('fetchPrivateFeed')
      //   let feed= this.$store.state.friends
      //   for(let fed in feed){
      //   if(feed[fed].me === true && feed[fed].them === true) {
      //     this.$store.dispatch('fetchPrivateFeedFromFriends', feed[fed].friendId)
      //   }
      // }
        this.$store.dispatch('firebaseGetPostInteraction')
      },
      viewport(){
        this.view = this.$vuetify.breakpoint.name;
      }
    },
    mounted() {

      // check viewport size
      this.viewport()
      this.$store.state.fetchFeed = []
      this.$store.dispatch('fetchFeed')
      this.$store.dispatch('fetchPrivateFeed')
      this.$store.dispatch('firebaseDeletePosts')

      let feed= this.$store.state.friends
      for(let fed in feed){
        if(feed[fed].me === true && feed[fed].them === true) {
          this.$store.dispatch('fetchPrivateFeedFromFriends', feed[fed].friendId)
        }
      }
      this.$store.dispatch('firebaseGetPostInteraction')
      this.$store.dispatch('firebaseDeletePosts')
    this.$store.dispatch('firebaseGetGroupChat')
    this.$store.dispatch('firebaseGetNotifications')

    }
  }
</script>

<style lang="scss" scoped>

  .lg {
    .feed-post {
      max-width: 55%;
    }
  }

  .xs {
    .container {
      margin: 0;
      padding: 0 0 2vh 0;
    }
    .feed-post {
      width: 100%;
    }
  }

</style>
